
import { ChangeEvent } from 'react';
import { DEBUG } from '../../../config';
import React, { FC, memo, useState, useEffect } from '../../../lib/teact/teact'
import Button from '../../ui/Button';
import Checkbox from '../../ui/Checkbox';
import ConfirmDialog from '../../ui/ConfirmDialog';
import InputText from '../../ui/InputText';
import RadioGroup from '../../ui/RadioGroup';
import { loadDefaultContactConfig, updateContactConfig, updateContactData } from '../redux/contactsSlice';

import { Dai } from '../types/types';
import LotCheckBox from '../ui/lotCheckBox';
import './contact.scss'
import store from '../store';
import { DBManager } from '../db/dbManager';
import LotLoading from '../ui/loading';
import { GetMienCuPhapID, GetUserFullInfo, GetUserID, isCuPhapMb, isCuPhapMn } from '../utils/common';
import { AdminApi } from '../restapi/adminApi';
import Snackbar from '../ui/snackbar';
import { ContactsApi } from '../restapi/contactsApi';
import { isValidTime } from '../utils/DateTimeUtils';
import { globalDexieDb } from '../db/DexiedbLib';
import { IDaiGioChot } from '../db/model/dmdai';
import { LoginApi } from '../restapi/loginApi';
import DonViTien from './donViTien';
import LotSelect from '../ui/lotSelect';
import MyTextInput from '../ui/myTextInput';
import { userInfo } from 'os';
import { enumDauVaoTinNhan } from '../commontypes';
import { e } from 'mathjs';

type OwerProps = {
    tinhIdProp: string;
    onDataChange: () => void;
    isGlobalConfig: boolean;
    globalSetting?: any;// trường hợp cài đặt chung cho user
    headerCount?: number;
    showMyHeader?: boolean | undefined;
    trigger: string;
}
const globalConfigChanged: string = "globalConfigChanged"
const ParserSettings: FC<OwerProps> = ({
    tinhIdProp,
    onDataChange,
    isGlobalConfig,// ==true,  lưu số liệu global cho user
    headerCount,
    showMyHeader,
    trigger,
    globalSetting,
}) => {
    const optionsDauDuoiLenTo = [
        { value: '2', label: "Nhận đến 2 chữ số", subLabel: "Ví dụ: 12, 34" },
        { value: '3', label: "Nhận đến 3 chữ số", subLabel: "Ví dụ: 012, 345" },
        { value: '4', label: "Nhận đến 4 chữ số", subLabel: "Ví dụ 0123,1234,5678" },
    ];
    const optionsDauVaoTinNhan = [
        { value: enumDauVaoTinNhan.telegramweb, label: "Tin nhắn telegram -web trực tiếp", subLabel: "Đăng nhập  tài khoản telegram của bạn trên web" },
        { value: enumDauVaoTinNhan.android, label: "Tin nhắn từ ứng dụng android", subLabel: "áp dụng cho máy android có cài ứng dụng lotteryvn" },
        { value: enumDauVaoTinNhan.bot, label: "Tin nhắn bot", subLabel: "Bạn đăng ký lấy tin từ nhóm có bot để tính tiền" },
        { value: enumDauVaoTinNhan.telegram, label: "Tin nhắn telegram-cloud trực tiếp", subLabel: "Đăng nhập trực tiếp tài khoản telegram của bạn vào cloud" },

    ];
    type dauVaoTinNhanKind = 'telegramweb' | 'android' | 'bot' | 'telegram'; // '0' | '1' | '2' | '3'

    const globalState = store.getState();
    /**Nếu là global thì chỉ có 1 hàng duy nhất thôi*/
    function getSelectedRow(tinhId: string) {
        let result;
        if (!isGlobalConfig) {
            for (let i = 0; i < globalState.contact.contactConfigArr.length; i++) {
                const curRow: any = globalState.contact.contactConfigArr[i]
                if (tinhId == curRow.tinhId) {
                    result = { ...curRow };
                }
            }
        } else {
            // đọc từ index db
            DBManager.getDBConnection().then((db) => {

                const getRequest = db.transaction('userConfig')
                    .objectStore('userConfig')
                    .get(tinhId);

                getRequest.onsuccess = (event: Event) => {
                    const tmp = getRequest.result;
                    setState((prev) => ({ ...prev, curConfigRow: tmp }))
                }
            })
        }
        return result
    };
    const [state, setState] = useState({
        curConfigRow: undefined as any,
        curTinh: tinhIdProp,
        showDefaultDialog: false,
        dmTinh: [],
        donViTien: store.getState().contact.donViTien,
        showSnackbar: false,
        snackbarMessage: "",
        gioChotMb: "18:14:00",
        gioChotMt: "17:14:00",
        gioChotMn: "16:14:00",
        userFullInfo: { ...GetUserFullInfo() },

    })
    function handleTinhIdChange(e: ChangeEvent<HTMLSelectElement>) {
        //console.log('handleTinhIdChange',e)
        const tinhId = e.target.value;
        const row = getSelectedRow(tinhId);
        if (!isGlobalConfig) {
            setState({ ...state, curTinh: tinhId, curConfigRow: row })
            store.dispatch(updateContactData({ fieldName: "tinhId", value: tinhId }))
        } else {
            setState((prev) => ({ ...prev, curTinh: tinhId }))
        }
        if (DEBUG)
            console.log(e)
        onDataChange ? onDataChange() : undefined
    }
    function setConfigValue(fieldName: string, value: number, tmp :any) {
        switch (fieldName) {
            case "mienChiaTien1":                 
            case "mienChiaTien2":                 
            case "mienChiaTien4":
                tmp["mienChiaTien"]=value;
                return  
        }
        tmp[fieldName] = value;
    }
    function handleConfigChangeCheckbox(payload: { fieldName: string, value: number, tinhId: string, valueExtra?: number }) {
        const valToSet = calculateCheckBoxValue(payload.value, payload.fieldName);
        payload["valueExtra"] = valToSet;
        if (!isGlobalConfig) {
            let tmp = { ...state.curConfigRow }
            setConfigValue(payload.fieldName, valToSet, tmp);
            setState({ ...state, curConfigRow: tmp })
            store.dispatch(updateContactConfig(payload));
        } else {
            // udpate indexDb
            DBManager.getDBConnection().then((db) => {
                const transaction = db.transaction("userConfig", "readwrite")
                const objectStore = transaction.objectStore("userConfig")
                const getRequest = objectStore.get(state.curTinh)
                getRequest.onsuccess = (event: Event) => {
                    const tmp = getRequest.result;
                    setConfigValue(payload.fieldName, valToSet, tmp);
                    const updateRequest = objectStore.put(tmp);
                    updateRequest.onerror = () => {
                        if (DEBUG)
                            console.log("cập nhật userConfig lỗi")
                    }
                    updateRequest.onsuccess = () => {
                        if (DEBUG)
                            console.log(`cập nhật userConfig thành công tinhId:${state.curTinh}`)
                        setState({ ...state, curConfigRow: tmp })
                        localStorage[globalConfigChanged] = true;
                    }
                }
            })
        }
        onDataChange ? onDataChange() : undefined
    }
    function calculateCheckBoxValue(value: number, fieldName: string,) {

        let curValue = state.curConfigRow[fieldName] || 0;
        switch (fieldName) {
            case "mienChiaTien1":
                curValue = state.curConfigRow["mienChiaTien"];
                if (value == 1)
                    return 1 | curValue;
                else
                    return curValue  ^ 1;
            case "mienChiaTien2":
                curValue = state.curConfigRow["mienChiaTien"];
                if (value == 2)
                    return 2 | curValue;
                else
                    return curValue  ^ 2;
            case "mienChiaTien4":
                curValue = state.curConfigRow["mienChiaTien"];
                if (value == 4)
                    return 4 | curValue;
                else
                    return curValue  ^ 4;
        }
        return value;
    }
    function handleDauDuoiLenToChange(valueStr: string, event: ChangeEvent<HTMLInputElement>) {
        const value = Number(valueStr);
        if (isNaN(value)) {
            return;
        }
        if (DEBUG)
            console.log(value)
        if (!isGlobalConfig) {
            let tmp = { ...state.curConfigRow }
            tmp["dauDuoiLenTo"] = value;
            setState({ ...state, curConfigRow: tmp })
            const payload = { fieldName: "dauDuoiLenTo", value: value, tinhId: state.curTinh }
            store.dispatch(updateContactConfig(payload));
        } else {
            // udpate indexDb
            DBManager.getDBConnection().then((db) => {
                const transaction = db.transaction("userConfig", "readwrite")
                const objectStore = transaction.objectStore("userConfig")
                const getRequest = objectStore.get(state.curTinh)
                getRequest.onsuccess = (event: Event) => {
                    const tmp = getRequest.result;
                    tmp["dauDuoiLenTo"] = value;
                    const updateRequest = objectStore.put(tmp);
                    updateRequest.onerror = () => {
                        if (DEBUG)
                            console.log("cập nhật userConfig lỗi")
                    }
                    updateRequest.onsuccess = () => {
                        if (DEBUG)
                            console.log(`cập nhật userConfig thành công tinhId:${state.curTinh}`)
                        setState({ ...state, curConfigRow: tmp })
                        localStorage[globalConfigChanged] = true;
                    }
                }
            })
        }
        onDataChange ? onDataChange() : undefined
    }
    function handleDauVaoTinNhanChange(kind: keyof typeof enumDauVaoTinNhan, event: ChangeEvent<HTMLInputElement>) {
        //suDungTinBot ; sử dụng tin android, 1 sử dụng tin bot, 2 sử dụng tin telegram trực tiếp
        const value = kind
        const userInfo = GetUserFullInfo()
        switch (value) {
            case enumDauVaoTinNhan.telegramweb:
                userInfo.suDungTinAndroid = 0
                userInfo.suDungTinBot = 0
                updateSuDungTinAndroid(userInfo.suDungTinAndroid);
                updateSuDungTinBot(userInfo.suDungTinBot);
                break;
            case enumDauVaoTinNhan.android:
                userInfo.suDungTinAndroid = 1
                userInfo.suDungTinBot = 0
                updateSuDungTinAndroid(userInfo.suDungTinAndroid);
                updateSuDungTinBot(userInfo.suDungTinBot);
                break;
            case enumDauVaoTinNhan.bot:
                userInfo.suDungTinAndroid = 0
                userInfo.suDungTinBot = 2
                updateSuDungTinAndroid(userInfo.suDungTinAndroid);
                updateSuDungTinBot(userInfo.suDungTinBot);; // vì vấn đề tương thích củ chuối, đáng lẽ chỉ cần dùng 1 field là suDungTinBot là đủ
                break;
            case enumDauVaoTinNhan.telegram:
                userInfo.suDungTinAndroid = 0
                userInfo.suDungTinBot = 3
                updateSuDungTinAndroid(userInfo.suDungTinAndroid);
                updateSuDungTinBot(userInfo.suDungTinBot);
                break;

        }

        localStorage['userFullInfo'] = JSON.stringify(userInfo)
        console.log('userInfo after change dau vao tin nhan android,bot:', userInfo.suDungTinAndroid, userInfo.suDungTinBot)
    }
    function handleKyTuPhanCachChange(value: string, event: ChangeEvent<HTMLInputElement>) {
        if (DEBUG)
            console.log(value)
        if (!isGlobalConfig) {
            let tmp = { ...state.curConfigRow }
            tmp["kytuphancach"] = value;
            setState({ ...state, curConfigRow: tmp })
            const payload = { fieldName: "kytuphancach", value: value, tinhId: state.curTinh }
            store.dispatch(updateContactConfig(payload));
        } else {
            // udpate indexDb
            DBManager.getDBConnection().then((db) => {
                const transaction = db.transaction("userConfig", "readwrite")
                const objectStore = transaction.objectStore("userConfig")
                const getRequest = objectStore.get(state.curTinh)
                getRequest.onsuccess = (event: Event) => {
                    const tmp = getRequest.result;
                    tmp["kytuphancach"] = value;
                    const updateRequest = objectStore.put(tmp);
                    updateRequest.onerror = () => {
                        if (DEBUG)
                            console.log("cập nhật userConfig lỗi")
                    }
                    updateRequest.onsuccess = () => {
                        if (DEBUG)
                            console.log(`cập nhật userConfig thành công tinhId:${state.curTinh}`)
                        setState({ ...state, curConfigRow: tmp })
                        localStorage[globalConfigChanged] = true;
                    }
                }
            })
        }
        onDataChange ? onDataChange() : undefined
    }
    function handleTextFieldChange(fieldName: string, value: string, event: ChangeEvent<HTMLInputElement>) {
        if (DEBUG)
            console.log(value)
        if (!isGlobalConfig) {

            let tmp = { ...state.curConfigRow }
            tmp[fieldName] = value;
            setState({ ...state, curConfigRow: tmp })
            const payload = { fieldName: fieldName, value: value, tinhId: state.curTinh }
            store.dispatch(updateContactConfig(payload));
        } else {
            // udpate indexDb
            if (fieldName == "gioChotLo" || fieldName == "gioChotDe") {
                const valid = isValidTime(value)
                if (!valid) {
                    return;
                }
                const userId = Number(GetUserID())
                const g = globalDexieDb.daiGioChot.where("[userId+daiId]").equals([userId, 'HN']).first()
                g.then((row: IDaiGioChot | undefined) => {
                    if (row) {
                        if (fieldName == 'gioChotLo') {
                            row!.gioMoThuong = value
                        } else if (fieldName == 'gioChotDe') {
                            row!.gioRaDacBiet = value
                        }
                        globalDexieDb.daiGioChot.put(row!)
                    }
                })
            }
            DBManager.getDBConnection().then((db) => {
                const transaction = db.transaction("userConfig", "readwrite")
                const objectStore = transaction.objectStore("userConfig")
                const getRequest = objectStore.get(state.curTinh)
                getRequest.onsuccess = (event: Event) => {
                    const tmp = getRequest.result;
                    tmp[fieldName] = value;
                    const updateRequest = objectStore.put(tmp);
                    updateRequest.onerror = () => {
                        if (DEBUG)
                            console.log("cập nhật userConfig lỗi")
                    }
                    updateRequest.onsuccess = () => {
                        if (DEBUG)
                            console.log(`cập nhật userConfig thành công tinhId:${state.curTinh}`)
                        setState({ ...state, curConfigRow: tmp })
                        localStorage[globalConfigChanged] = true;
                    }
                }
            })
        }
        onDataChange ? onDataChange() : undefined
    }
    function handleTimeFieldChange(fieldName: string, value: string) {
        const valid = isValidTime(value)
        console.log(`the time valid is :${valid}`)
        const payload = { gioChotMb: state.gioChotMb, gioChotMt: state.gioChotMt, gioChotMn: state.gioChotMn }
        if (valid) {
            switch (fieldName) {
                case "gioChotMb":
                    setState(prev => ({ ...prev, gioChotMb: value }))
                    payload.gioChotMb = value
                    break;
                case "gioChotMn":
                    setState(prev => ({ ...prev, gioChotMn: value }))
                    payload.gioChotMn = value
                    break;
                case "gioChotMt":
                    setState(prev => ({ ...prev, gioChotMt: value }))
                    payload.gioChotMt = value
                    break;
            }
            ContactsApi.setGioChot(payload).then(res => {
                if (DEBUG)
                    console.log(res)
            })

        }
    }
    function handleYeuCauRoChange(fieldName: string, value: string, event: ChangeEvent<HTMLInputElement>) {
        let val = Number(value)
        if (isNaN(val))
            val = 0
        if (DEBUG)
            console.log(value)
        if (!isGlobalConfig) {
            let tmp = { ...state.curConfigRow }
            tmp[fieldName] = val;
            setState({ ...state, curConfigRow: tmp })
            const payload = { fieldName: fieldName, value: val, tinhId: state.curTinh }
            store.dispatch(updateContactConfig(payload));
        } else {
            // udpate indexDb
            DBManager.getDBConnection().then((db) => {
                const transaction = db.transaction("userConfig", "readwrite")
                const objectStore = transaction.objectStore("userConfig")
                const getRequest = objectStore.get(state.curTinh)
                getRequest.onsuccess = (event: Event) => {
                    const tmp = getRequest.result;
                    tmp[fieldName] = val;
                    const updateRequest = objectStore.put(tmp);
                    updateRequest.onerror = () => {
                        if (DEBUG)
                            console.log("cập nhật userConfig lỗi")
                    }
                    updateRequest.onsuccess = () => {
                        if (DEBUG)
                            console.log(`cập nhật userConfig thành công tinhId:${state.curTinh}`)
                        setState({ ...state, curConfigRow: tmp })
                        localStorage[globalConfigChanged] = true;
                    }
                }
            })
        }
        onDataChange ? onDataChange() : undefined
    }
    function handleDaiDefaultChange({ fieldName, value, tinhId }: { fieldName: string, value: string | number, tinhId: string }) {
        let dai = 0;
        let propName = "areaDefaultMn";
        if (fieldName == "dai5" || fieldName == "dai6" || fieldName == "dai7" || fieldName == "dai8")
            propName = "areaDefaultMt";
        switch (fieldName) {
            case "dai1":
                dai = Dai.DAI_1;
                break;
            case "dai2":
                dai = Dai.DAI_2;
                break;
            case "dai3":
                dai = Dai.DAI_3;
                break;
            case "dai4":
                dai = Dai.DAI_4;
                break;
            case "dai5":
                dai = Dai.DAI_5;
                break;
            case "dai6":
                dai = Dai.DAI_6;
                break;
            case "dai7":
                dai = Dai.DAI_7;
                break;
            case "dai8":
                dai = Dai.DAI_8;
                break;
        }
        if (!isGlobalConfig) {
            for (let i = 0; i < globalState.contact.contactConfigArr.length; i++) {
                const row: any = globalState.contact.contactConfigArr[i];
                if (row.tinhId == tinhId) {
                    let daiInt = globalState.contact.contactConfigArr[i][propName]
                    const tmpRow = { ...state.curConfigRow }
                    let newDai = daiInt | dai
                    if (!value) //ko check thì dùng xor để xoá đi
                        newDai = daiInt ^ dai;
                    tmpRow[propName] = newDai
                    setState({ ...state, curConfigRow: tmpRow })
                    store.dispatch(updateContactConfig({ fieldName: propName, value: newDai, tinhId }))
                }
            }
        } else {
            // udpate indexDb
            DBManager.getDBConnection().then((db) => {
                const transaction = db.transaction("userConfig", "readwrite")
                const objectStore = transaction.objectStore("userConfig")
                const getRequest = objectStore.get(state.curTinh)
                getRequest.onsuccess = (event: Event) => {
                    const tmp = getRequest.result;
                    let daiInt = tmp[propName]
                    let newDai = daiInt | dai
                    if (!value) //ko check thì dùng xor để xoá đi
                        newDai = daiInt ^ dai;
                    tmp[propName] = newDai;
                    const updateRequest = objectStore.put(tmp);
                    updateRequest.onerror = () => {
                        if (DEBUG)
                            console.log("cập nhật userConfig lỗi")
                    }
                    updateRequest.onsuccess = () => {
                        if (DEBUG)
                            console.log(`cập nhật userConfig.${propName} thành công tinhId:${state.curTinh}`)
                        setState({ ...state, curConfigRow: tmp })
                        localStorage[globalConfigChanged] = true;
                    }
                }
            })
        }
        onDataChange ? onDataChange() : undefined
    }

    useEffect(() => {
        const tmp = getSelectedRow(state.curTinh)
        setState((prev) => ({ ...prev, curConfigRow: tmp }))
        ContactsApi.getGioChot().then(res => {
            setState((prev) => ({
                ...prev, gioChotMb: res.data.gioChotMb,
                gioChotMt: res.data.gioChotMt,
                gioChotMn: res.data.gioChotMn,
            }))
        })
        LoginApi.getUserFullInfo().then(res => {
            setState((prev) => ({
                ...prev, userFullInfo: res.data,
            }))
        })
    }, [])
    useEffect(() => {
        DBManager.getDBConnection().then((db) => {
            const request = db.transaction("dmTinh")
                .objectStore("dmTinh")
                .getAll()
            request.onsuccess = (e) => {
                setState((prev: any) => ({ ...prev, dmTinh: request.result }))
            }
        }
        )
    }, [])
    if (state.curConfigRow == undefined) {
        return <LotLoading />
    }
    useEffect(() => {
        if (tinhIdProp != state.curTinh)
            getSelectedRow(tinhIdProp)
        setState(prev => ({ ...prev, curTinh: tinhIdProp }))

    }, [tinhIdProp])
    function handleDefault() {
        DBManager.getDBConnection().then(db => {
            const trans = db.transaction("userConfig")
            const get = trans.objectStore("userConfig").get(state.curTinh)
            get.onsuccess = () => {
                const { userId, ...newObj } = get.result;
                const newData = { ...newObj, contactId: state.curConfigRow!.contactId }
                setState(prev => ({ ...prev, showDefaultDialog: false, curConfigRow: newData }))
                store.dispatch(loadDefaultContactConfig(newData));
            }
        })
    }

    function showSnackbar(message: string) {
        setState(prev => ({ ...prev, snackbarMessage: message, showSnackbar: true }))
    }
    async function updateSuDungTinAndroid(suDung: number) {
        return LoginApi.updateSuDungTinAndroid(suDung)
    }
    async function updateSuDungTinBot(suDung: number) {
        return LoginApi.updateSuDungTinBot(suDung)
    }
    async function updateSapXepTin(sapXep: number) {
        return LoginApi.updateSapXepTin(sapXep)
    }
    const mienCuPhapId = GetMienCuPhapID()
    return (
        <>
            {(showMyHeader || showMyHeader == undefined) && <div className="contact-config-header">
                <div className='contact-config-header left-panel'>
                    <div className="contact-cai-dat-tinh">
                        <div >Sử dụng cú pháp vùng</div>
                        <select className="custom-select" value={state.curTinh}
                            onChange={handleTinhIdChange}
                        >
                            {
                                state.dmTinh.filter((it: any) => it.mienCuPhapId == mienCuPhapId).map((item: any, index: number) => {
                                    return <option value={item.tinhId} selected={state.curTinh == item.tinhId} >{item.tenTinh}</option>
                                })
                            }
                        </select>
                    </div>
                    <Button round
                        size="default"
                        color="translucent"
                        onClick={() => { setState({ ...state, showDefaultDialog: true }) }}
                    >
                        <i className="fa-solid fa-tent-arrows-down"></i>

                    </Button>
                </div>
            </div>
            }
            <div className={headerCount == 3 ? "contact-config-content-3-header" : "contact-config-content"}>
                <div className="contact-config-section-item">
                    <div className="contact-config-section-header">Cài đặt chung</div>
                    <Checkbox label="Ưu tiên xử lý từ khoá thay thế" value="parseCustomeWordFirst"
                        checked={(state.curConfigRow.parseCustomeWordFirst) == 1}
                        subLabel='Khi phân tích, các từ khoá dùng để thay thế sẽ được ưu tiên xử lý trước tiên, sau đó mới xử lý các từ khoá khác'
                        onChange={(e) => {
                            const sd = e.target.checked ? 1 : 0
                            handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })

                        }}
                    />
                    <Checkbox label="Tin trả lại gom theo nhóm đài,loại" value="gopTinTraLai"
                        checked={(state.curConfigRow.gopTinTraLai) == 1}
                        subLabel='Tin trả lại cho khách được gom theo nhóm đài, loại cược, thay vì tách riêng từng đài, loại cược. ví dụ vl,tv 01 dd1n thay vi vl 01 dd 1n ,tv 01 dd 1n'
                        onChange={(e) => {
                            const sd = e.target.checked ? 1 : 0
                            handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })

                        }}
                    />


                    <Checkbox label="Yêu cầu ghi rõ mc, =, x trước số tiền" value="yeuCauToanTuTien"
                        checked={(state.curConfigRow.yeuCauToanTuTien) == 1}
                        subLabel='Yêu cầu ghi rõ mc, =, x trước số tiền, ví dụ dch 00 01 02 dd 600n pm sẽ báo lỗi vì không ghi rõ mc, =, x trước số tiền'
                        onChange={(e) => {
                            const sd = e.target.checked ? 1 : 0
                            handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })

                        }}
                    />
                    {isGlobalConfig && <>
                        <Checkbox label="Hiển thị kết quả trực tiếp"
                            checked={localStorage['kq_tructiep'] == "1"
                                /* || localStorage['kq_tructiep'] == undefined */}
                            value="kq_tructiep"
                            subLabel=""
                            onChange={(e) => {
                                localStorage['kq_tructiep'] = e.target.checked ? "1" : "0"

                            }}
                        />

                        <Checkbox label="Tự động phân tích tin đến"
                            checked={state.curConfigRow.autoParseIn == "1"}
                            value="autoParseIn"
                            subLabel=""
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Tự động phân tích tin đi"
                            checked={state.curConfigRow.autoParseOut == "1"}
                            value="autoParseOut"
                            subLabel=""
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        {/* {isCuPhapMn() && <>
                            <InputText label='Miền Nam nhận đến (giờ:phút:giây - định dạng 24h)'
                                onChange={(e) => {
                                    handleTimeFieldChange('gioChotMn', e.target.value)
                                }}
                                value={state.gioChotMn}></InputText>
                            <InputText label='Miền Trung nhận đến (giờ:phút:giây - định dạng 24h)'
                                onChange={(e) => {
                                    handleTimeFieldChange('gioChotMt', e.target.value)
                                }}
                                value={state.gioChotMt}></InputText>
                            <InputText label='Miền Bắc nhận đến (giờ:phút:giây - định dạng 24h)'
                                onChange={(e) => {
                                    handleTimeFieldChange('gioChotMb', e.target.value)
                                }}
                                value={state.gioChotMb}></InputText>
                        </>

                        } */}
                        <InputText label='Giờ chốt lô MB (giờ:phút:giây - định dạng 24h)'
                            onChange={(e) => { handleTextFieldChange("gioChotLo", e.target.value, e) }}
                            value={state.curConfigRow.gioChotLo}></InputText>
                        <InputText label='Giờ chốt đề MB(giờ:phút:giây - định dạng 24h)'
                            onChange={(e) => handleTextFieldChange("gioChotDe", e.target.value, e)}
                            value={state.curConfigRow.gioChotDe}></InputText>
                    </>}

                    {isCuPhapMb() && <>


                        <Checkbox label="Khi dùng dấu =, báo lỗi nếu không ghi rõ mc hay tất cả"
                            checked={state.curConfigRow.xuLyDauBang == "1"}
                            value="xuLyDauBang"
                            subLabel=""
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận đơn vị tính 'điểm' cho đề"
                            checked={state.curConfigRow.mbDeNhanDiem == "1"}
                            value="mbDeNhanDiem"
                            subLabel=""
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận đơn vị tính 'n' cho lô"
                            checked={state.curConfigRow.mbLoNhanNghin == "1"}
                            value="mbLoNhanNghin"
                            subLabel=""
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <InputText label="Các loại ĐỀ ab,Nhất,3c Yêu cầu ghi rõ khi lớn hơn"
                            value={state.curConfigRow["mbYcDvtDeLonHon"]}
                            onChange={(e) => { handleYeuCauRoChange("mbYcDvtDeLonHon", e.target.value, e) }}
                        />
                        <InputText label="Các loại LÔ ab,  Yêu cầu ghi rõ khi lớn hơn"
                            value={state.curConfigRow["mbYcDvtLoLonHon"]}
                            onChange={(e) => { handleYeuCauRoChange("mbYcDvtLoLonHon", e.target.value, e) }}
                        />
                        <InputText label="Các loại XIÊN ab,  Yêu cầu ghi rõ khi lớn hơn"
                            value={state.curConfigRow["mbYcDvtXienLonHon"]}
                            onChange={(e) => { handleYeuCauRoChange("mbYcDvtXienLonHon", e.target.value, e) }}
                        />
                    </>

                    }
                    <Checkbox label="Loại bỏ số tin nằm giữa tin nhắn"
                        checked={state.curConfigRow["loaiBoSoTinOGiuaTin"] == 1}
                        value="loaiBoSoTinOGiuaTin"
                        subLabel="Các phần đánh số tin nằm giữa tin nhắn khi bạn copy nhiều tin sẽ được tự động loại bỏ"
                        onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                    />
                    {isCuPhapMn() && <>
                        <Checkbox label="Không ghi loại cược, lấy từ thẻ đứng trước"
                            checked={state.curConfigRow.muonTypeSet == "1"}
                            value="muonTypeSet"
                            subLabel="ví dụ dch LO 01  1n. 02 1n thẻ 02 1n sẽ hiểu là lo. Chỉ áp dụng cho cách ghi đài,loại trước số cược (đài  loại số)"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Yêu cầu đồng nhất độ dài số cược trong cùng thẻ"
                            checked={state.curConfigRow["batBuocDongNhatDoDaiSoCuoc"] == 1}
                            value="batBuocDongNhatDoDaiSoCuoc"
                            subLabel="ví dụ: dch 12 345 lo1n -> sẽ báo lỗi vì dộ dài số cược là 2 và 3, khác nhau"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận loại cược ghi lặp lại"
                            checked={state.curConfigRow["choPhepLapLoaiCuoc"] == 1}
                            value="choPhepLapLoaiCuoc"
                            subLabel="dạng 1234 b1nb2nb3n"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="loại cược ghi lặp lại, yêu cầu ghi rõ đơn vị tiền"
                            checked={state.curConfigRow["lapLoaiCuocYeuCauChiRodvt"] == 1}
                            value="lapLoaiCuocYeuCauChiRodvt"
                            subLabel="dạng 1234 b1b2b3-> Lỗi. 1234 b1nb2nb3n -> Nhận"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận d=đá "
                            checked={state.curConfigRow["nhanDLaXien"] == 1}
                            value="nhanDLaXien"
                            subLabel="ví dụ dạng: 01,02,03d100n"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận DEN = KEO = TOI"
                            checked={state.curConfigRow["denNhuKeo"] == 1}
                            value="denNhuKeo"
                            subLabel="ví dụ 000den999=000keo999=000toi999. Bỏ check nếu 10 den(toi) 20=tu 10 den 20 "
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận cấu trúc ghi nhiều mục số tiền"
                            checked={state.curConfigRow["nhanCauTrucNhieuMucTien"] == 1}
                            value="nhanCauTrucNhieuMucTien"
                            subLabel="Dạng:  dch dph lo 10 10n 20n 30n"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận cấu trúc không ghi số tiền"
                            checked={state.curConfigRow["nhanCauTrucKoTien"] == 1}
                            value="nhanCauTrucKoTien"
                            subLabel="ví dụ: dch dph dau 10 200 duoi 89 200"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận cấu trúc nhiều loại cược trước 1 mục số tiền"
                            checked={state.curConfigRow["typeMultipleTypes"] == 1}
                            value="typeMultipleTypes"
                            subLabel="ví dụ: dch dph 01 g1 g2 dui 10n"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Kiểm tra nhập nhằng dấu trừ - với KÉO"
                            checked={state.curConfigRow["checkNhapNhangDauTruKeo"] == 1}
                            value="checkNhapNhangDauTruKeo"
                            subLabel="ví dụ: 1230-1239 một số khách sẽ nói đây là KÉO"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Kiểm tra nhập nhằng tiền lẻ với số cược"
                            checked={state.curConfigRow["checkNhapNhangSoCuocTienLe"] == 1}
                            value="checkNhapNhangSoCuocTienLe"
                            subLabel="ví dụ:dc 10dd10n lo 12.5n, nhiều khách có thể nói con lô 12 cược 5 n"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Nhận số tiền lẻ dạng 05"
                            checked={state.curConfigRow["nhanSoTienDang05"] == 1}
                            value="nhanSoTienDang05"
                            subLabel="ví dụ:dc 10 11dd10 lo 05 , da05 da 11 12 4n"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Ưu tiên nhận dạng tiền lẻ"
                            checked={state.curConfigRow["uuTienNhanTienThapPhan"] == 1}
                            value="uuTienNhanTienThapPhan"
                            subLabel="ví dụ:lo 275 12.5n sẽ ưu tiên nhận 12.5n là tiền cược thay vì 5n"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                         <Checkbox label="Phần nguyên 3 chữ số trở lên của tiền lẻ  yêu cầu ghi rõ *"
                            checked={state.curConfigRow["thapPhanMax2ChuSo"] == 1}
                            value="thapPhanMax2ChuSo"
                            subLabel="ví dụ:44.02 da4n lo 688,5n a10n b20n nếu muốn nhận 688 là tiền bắt buộc ghi rõ *688,5n, nếu bật lựa chọn này, phần mềm sẽ báo lỗi nếu không có dấu * phía trước 688"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Tách xỉu chủ"
                            checked={state.curConfigRow["tachXiuChu"] == 1}
                            value="tachXiuChu"
                            subLabel="Loại cược xỉu chủ sẽ được tách riêng thành 2 loại cược xc đầu và xc đuôi"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Yêu cầu ghi rõ đơn vị tiền"
                            checked={state.curConfigRow["ycDonViTien"] == 1}
                            value="ycDonViTien"
                            subLabel="Khi phân tích, yêu cầu ghi rõ đơn vị tiền, nếu không ghi sẽ báo lỗi, ví dụ: 1000n, 1trieu"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="'keo den' xử lý như 'keo'"
                            checked={state.curConfigRow["keoDenNhuKeo"] == 1}
                            value="keoDenNhuKeo"
                            subLabel="010 keo den 910 xử lý như 010 keo 910"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <div style="display:none">
                            <div>Ký tự ngắt cứng</div>loaiBoSoTinOGiuaTin
                            <input value={"; ,, .. // --"}></input>
                        </div>
                    </>}
                </div>
                <div className="contact-config-section-header">Cài đặt chia tiền</div>
                <div className="contact-config-section-item">
                    <Checkbox label="Tự động chia tiền khi phân tích" value="devideMoney"
                        checked={(state.curConfigRow.devideMoney) == 1}
                        subLabel='Khi cược người dùng nhập số tiền tổng, phần mềm tự động chia số tiền theo đài, số bộ số cược, ví dụ 2d 00 01 02 dd 600n pm sẽ chia mỗi con 50n (600/2/3/2)'
                        onChange={(e) => {
                            const sd = e.target.checked ? 1 : 0
                            handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })

                        }}
                    />
                    <div id="mienChiaTienDiv" style={(state.curConfigRow.devideMoney) == 1 ? 'display: block' : 'display:none'}>
                        <Checkbox label="Đài miền bắc" value="mienChiaTien1"
                            checked={(state.curConfigRow.mienChiaTien & 1) == 1}
                            subLabel=''
                            onChange={(e) => {
                                const sd = e.target.checked ? 1 : 0
                                handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })

                            }}
                        />
                        <Checkbox label="Đài miền trung" value="mienChiaTien2"
                            checked={(state.curConfigRow.mienChiaTien & 2) == 2}
                            subLabel=''
                            onChange={(e) => {
                                const sd = e.target.checked ? 1 : 0
                                handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 2 : 0, tinhId: state.curTinh })

                            }}
                        />
                        <Checkbox label="Đài miền nam" value="mienChiaTien4"
                            checked={(state.curConfigRow.mienChiaTien & 4) == 4}
                            subLabel=''
                            onChange={(e) => {
                                const sd = e.target.checked ? 1 : 0
                                handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 4 : 0, tinhId: state.curTinh })

                            }}
                        />
                    </div>
                </div>
                {isCuPhapMn() &&
                    <div className="contact-config-section-item">
                        <div className="contact-config-section-header">Phân tích Đầu, Đuôi</div>
                     
                        <RadioGroup
                            selected={state.curConfigRow["dauDuoiLenTo"] + ""}
                            name="channel-type-dau-duoi-len-to"
                            options={optionsDauDuoiLenTo}
                            onChange={handleDauDuoiLenToChange}
                        />
                    </div>
                }
                {isCuPhapMn() && <>
                    <div className="contact-config-section-item">
                        <div className="contact-config-section-header">Giới hạn số vòng đá xiên tối đa</div>
                        <MyTextInput label='số vòng'
                            value={state.curConfigRow["maxVongDaXien"]}


                            onChange={(e) => { handleTextFieldChange("maxVongDaXien", e.target.value, e) }}>

                        </MyTextInput>
                        <div>đặt bằng 100, nếu bạn không giới hạn</div>
                    </div>
                    <div className="contact-config-section-item">
                        <div className="contact-config-section-header">Cách tính thưởng đá thẳng Miền Bắc</div>
                        <Checkbox label="Đá thẳng miền bắc, thưởng 0.5 ki/nháy"
                            checked={state.curConfigRow["mbDat05"] == 1}
                            value="mbDat05"
                            subLabel="Tính thưởng đến 1.5 ki, nháy là nhiều nhất"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá thẳng miền bắc, thưởng 0.5 ki/nháy nhiều lần"
                            checked={state.curConfigRow["mbDat05NhieuLan"] == 1}
                            value="mbDat05NhieuLan"
                            subLabel="Tính thưởng 0.5 ki, nháy là nhiều lần"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá thẳng miền bắc, thưởng nhiều ki/nháy"
                            checked={state.curConfigRow["mbDat2"] == 1}
                            value="mbDat2"
                            subLabel="Tính thưởng 1,2,3,4,5 ki/nháy"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                    </div>
                    <div className="contact-config-section-item">
                        <div className="contact-config-section-header">Cách tính thưởng đá THẲNG miền Nam</div>
                        <Checkbox label="Đá thẳng  thưởng 0.5 ki/nháy"
                            checked={state.curConfigRow["mnDat05"] == 1}
                            value="mnDat05"
                            subLabel="Tính thưởng đến 1.5 ki, nháy là nhiều nhất"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá thẳng  thưởng 0.5 ki/nháy nhiều lần"
                            checked={state.curConfigRow["mnDat05NhieuLan"] == 1}
                            value="mnDat05NhieuLan"
                            subLabel="Tính thưởng 0.5 ki, nháy là nhiều lần"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá thẳng  thưởng nhiều ki/nháy"
                            checked={state.curConfigRow["mnDat2"] == 1}
                            value="mnDat2"
                            subLabel="Tính thưởng 1,2,3,4,5 ki/nháy"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                    </div>
                    <div className="contact-config-section-item">
                        <div className="contact-config-section-header">Cách tính thưởng đá XIÊN  miền Nam</div>
                        <Checkbox label="Đá xiên  thưởng 0.5 ki/nháy"
                            checked={state.curConfigRow["mnDax05"] == 1}
                            value="mnDax05"
                            subLabel="Tính thưởng đến 1.5 ki, nháy là nhiều nhất"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá xiên  thưởng 0.5 ki/nháy nhiều lần"
                            checked={state.curConfigRow["mnDax05NhieuLan"] == 1}
                            value="mnDax05NhieuLan"
                            subLabel="Tính thưởng 0.5 ki, nháy nhiều lần"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá xiên  thưởng nhiều ki/nháy"
                            checked={state.curConfigRow["mnDax2"] == 1}
                            value="mnDax2"
                            subLabel="Tính thưởng 1,2,3,4,5 ki/nháy"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                    </div>
                    <div className="contact-config-section-item">
                        <div className="contact-config-section-header">Cách tính thưởng đá THẲNG miền Trung</div>
                        <Checkbox label="Đá thẳng thưởng 0.5 ki/nháy"
                            checked={state.curConfigRow["mtDat05"] == 1}
                            value="mtDat05"
                            subLabel="Tính thưởng đến 1.5 ki, nháy là nhiều nhất"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá thẳng  thưởng 0.5 ki/nháy nhiều lần"
                            checked={state.curConfigRow["mtDat05NhieuLan"] == 1}
                            value="mtDat05NhieuLan"
                            subLabel="Tính thưởng 0.5 ki, nháy là nhiều lần"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá thẳng  thưởng nhiều ki/nháy"
                            checked={state.curConfigRow["mtDat2"] == 1}
                            value="mtDat2"
                            subLabel="Tính thưởng 1,2,3,4,5 ki/nháy"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                    </div>
                    <div className="contact-config-section-item">
                        <div className="contact-config-section-header">Cách tính thưởng đá XIÊN  miền Trung</div>
                        <Checkbox label="Đá xiên  thưởng 0.5 ki/nháy"
                            checked={state.curConfigRow["mtDax05"] == 1}
                            value="mtDax05"
                            subLabel="Tính thưởng đến 1.5 ki, nháy là nhiều nhất"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá xiên  thưởng 0.5 ki/nháy nhiều lần"
                            checked={state.curConfigRow["mtDax05NhieuLan"] == 1}
                            value="mtDax05NhieuLan"
                            subLabel="Tính thưởng 0.5 ki, nháy nhiều lần"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá xiên  thưởng nhiều ki/nháy"
                            checked={state.curConfigRow["mtDax2"] == 1}
                            value="mtDax2"
                            subLabel="Tính thưởng 1,2,3,4,5 ki/nháy"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                    </div>
                </>}
                <div className="contact-config-section-item">
                    <div className="contact-config-section-header">{isCuPhapMn() ? "Phân tích đá, xiên" : "Phân tích xiên"}</div>
                    {isCuPhapMb() && <>
                        <InputText label="Đơn vị tính xiên ngầm định khi không ghi (n hoặc d)"
                            value={state.curConfigRow["mbDvtXienNgamDinh"]}
                            onChange={(e) => { handleTextFieldChange("mbDvtXienNgamDinh", e.target.value, e) }}
                        />
                    </>}
                    <InputText label="Chỉ nhận các ký tự phân cách sau"
                        value={state.curConfigRow["kytuphancach"]}
                        onChange={(e) => { handleKyTuPhanCachChange(e.target.value, e) }}

                    />
                    <Checkbox label="Không nhận số trùng trong thẻ xiên"
                        checked={state.curConfigRow["khongChapNhanSoTrungTheXien"] == 1}
                        value="khongChapNhanSoTrungTheXien"
                        subLabel={isCuPhapMn() ? "ví dụ dch 00 00 01 da 1n -> sẽ báo lỗi" : "ví dụ :xi  00 00 01 x 1n -> sẽ báo lỗi"}
                        onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                    />
                    <Checkbox label="Báo lỗi thẻ không ghi số cược, chỉ ghi tiền"
                        checked={state.curConfigRow["baoLoiTheKhongCoSoCuoc"] == 1}
                        value="baoLoiTheKhongCoSoCuoc"
                        subLabel={isCuPhapMn() ? "ví dụ da 00 11 10n lo 20n -> sẽ báo lỗi:lo 20n" : "ví dụ :xi  00 00 01 x 1n lo 20d -> sẽ báo lỗi:lo 20d"}
                        onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                    />
                    {isCuPhapMn() && <>
                        <Checkbox label="Nhận dạng tin đá kiểu 01 da 02 03 da 04"
                            checked={state.curConfigRow["nhanDang01Da02"] == 1}
                            value="nhanDang01Da02"
                            subLabel="ví dụ: 01 da  02 03 da 04 05 da 06 100n xien 01&02...03&04...05&06 1n"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá 2 đài hiểu là đá xiên"
                            checked={state.curConfigRow["xiToDc2dai"] == 1}
                            value="xiToDc2dai"
                            subLabel="Đá 2 đài, không ghi rõ dax, nhận là đá xiên, ví dụ 2d 01,02 da 1n. (Bỏ tích ô này, tính là đá thẳng từng đài)"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        />
                        <Checkbox label="Đá 3 đài hiểu là đá xiên"
                            checked={state.curConfigRow["xiToDc3dai"] == 1}
                            value="xiToDc3dai"
                            subLabel="Đá 3 đài, không ghi rõ dax, nhận là đá xiên, ví dụ 3d 01,02 da 1n. (Bỏ tích ô này, tính là đá thẳng từng đài)"
                            onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                        /> </>
                    }
                    <Checkbox label="Tách số xiên theo ký tự phân cách"
                        checked={state.curConfigRow["tachXien"] == 1}
                        value="tachXien"
                        subLabel="dạng (00,01,02) (03,04,05) hoặc 00 01 02/03 04 05 sẽ tách theo các ký tự phân cách trước, sau đó mới tính các bộ số theo từng nhóm"
                        onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                    />

                    <Checkbox label="Loại bớt ký tự phân cách"
                        checked={state.curConfigRow["repeatReduction"] == 1}
                        value="repeatReduction"
                        subLabel="Khi các ký tự phân cách ghi lặp lại, ví dụ 3 dấu chấm ghi liền nhau ... sẽ loại bớt chỉ tính là 1 dấu chấm ."
                        onChange={(e) => { handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh }) }}
                    />
                </div>
                {isCuPhapMn() && <>
                    <div className="contact-config-section-item">
                        <div className="contact-config-section-header">Đài ngầm định miền Nam</div>
                        <div className="contact-config-section-item-chon-dai">
                            <LotCheckBox text="Dch" value="dai1"
                                checked={(state.curConfigRow["areaDefaultMn"] & Dai.DAI_1) != 0}
                                onChange={(e) => handleDaiDefaultChange({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: (state.curTinh) })}
                            />
                            <LotCheckBox text="Dph1" value="dai2"
                                checked={(state.curConfigRow["areaDefaultMn"] & Dai.DAI_2) != 0}
                                onChange={(e) => handleDaiDefaultChange({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: (state.curTinh) })}
                            />
                            <LotCheckBox text="Dph2" value="dai3"
                                checked={(state.curConfigRow["areaDefaultMn"] & Dai.DAI_3) != 0}
                                onChange={(e) => handleDaiDefaultChange({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: (state.curTinh) })}
                            />
                            <LotCheckBox text="Dph3" value="dai4"
                                checked={(state.curConfigRow["areaDefaultMn"] & Dai.DAI_4) != 0}
                                onChange={(e) => handleDaiDefaultChange({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: (state.curTinh) })}
                            />
                        </div>
                    </div>
                    <div className="contact-config-section-item ">
                        <div className="contact-config-section-header">Đài ngầm định miền Trung</div>
                        <div className="contact-config-section-item-chon-dai">
                            <LotCheckBox text="Dch" value="dai5"
                                checked={(state.curConfigRow["areaDefaultMt"] & Dai.DAI_5) != 0}
                                onChange={(e) => handleDaiDefaultChange({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: (state.curTinh) })}
                            />
                            <LotCheckBox text="Dph1" value="dai6"
                                checked={(state.curConfigRow["areaDefaultMt"] & Dai.DAI_6) != 0}
                                onChange={(e) => handleDaiDefaultChange({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })}
                            />
                            <LotCheckBox text="Dphu2" value="dai7"
                                checked={(state.curConfigRow["areaDefaultMt"] & Dai.DAI_7) != 0}
                                onChange={(e) => handleDaiDefaultChange({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })}
                            />
                            <LotCheckBox text="Dphu3" value="dai8"
                                checked={(state.curConfigRow["areaDefaultMt"] & Dai.DAI_8) != 0}
                                onChange={(e) => handleDaiDefaultChange({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })}
                            />
                        </div>

                    </div>
                    <div className="contact-config-section-item ">
                        <div className="contact-config-section-header">Quy đổi các đơn vị tiền khác</div>
                        <div className="contact-config-section-item-chon-dai">
                            <DonViTien donViTien={state.donViTien} />
                        </div>

                    </div>
                </>}
                {isGlobalConfig &&
                    <div className="contact-config-section-item ">
                        <div className="contact-config-section-header">Đầu vào tin nhắn </div>
                        <RadioGroup
                            selected={state.userFullInfo.suDungTinBot + ""}
                            name="channel-type"
                            options={optionsDauVaoTinNhan}
                            onChange={(kind, e) => handleDauVaoTinNhanChange(kind, e)}
                        />


                        <div className="contact-config-section-item-chon-dai">
                            <div className=" common-container-row">
                                <div>Vai trò của chủ nhóm có bot</div>
                                <LotSelect
                                    id='selectedAgent'
                                    value={state.userFullInfo.vaiTroBot}
                                    onChange={(e) => {
                                        setState(prev => {
                                            const tmp = { ...prev, userFullInfo: { ...prev.userFullInfo, vaiTroBot: e.target.value } }
                                            localStorage['userFullInfo'] = JSON.stringify(tmp.userFullInfo)
                                            return tmp
                                        })
                                        LoginApi.updateVaiTroBot(e.target.value)
                                    }}
                                >
                                    <option value="1" selected={state.userFullInfo.vaiTroBot == "1"}>Khách</option>
                                    <option value="2" selected={state.userFullInfo.vaiTroBot == "2"}>Chủ</option>
                                </LotSelect>
                            </div>
                        </div>
                        <div className="contact-config-section-header">Sắp xếp tin nhắn</div>
                        <div className="contact-config-section-item-chon-dai">
                            <Checkbox label="Sắp xếp tin nhắn giảm dần" value="sapXepTin"
                                checked={(state.userFullInfo.sapXepTin) == 2}
                                subLabel='Bỏ check nếu bạn muốn sắp xếp tin nhắn tăng dần'
                                onChange={(e) => {
                                    const sd = e.target.checked ? 2 : 1
                                    //handleConfigChangeCheckbox({ fieldName: e.target.value, value: e.target.checked ? 1 : 0, tinhId: state.curTinh })
                                    updateSapXepTin(sd).then(res => {
                                        if (res.errorCode == 0) {
                                            setState(prev => {
                                                const tmp = { ...prev, userFullInfo: { ...prev.userFullInfo, sapXepTin: sd } }
                                                localStorage['userFullInfo'] = JSON.stringify(tmp.userFullInfo)
                                                return tmp
                                            })

                                        }
                                    })

                                }}
                            />
                        </div>
                    </div>
                }

            </div>
            <ConfirmDialog
                title='Đặt về cài đặt ngầm dịnh'
                text='Bạn có muốn cài đặt tất cả tham số danh bạ này theo cài đặt tài khoản do bạn thiết lập ban đầu?'
                confirmLabel='Đồng ý'
                isOpen={state.showDefaultDialog}
                onClose={() => { setState({ ...state, showDefaultDialog: false }) }}
                confirmHandler={handleDefault}
            />
            <Snackbar isOpen={state.showSnackbar} message={state.snackbarMessage}
                triggerTime={""}
                onClose={() => { setState({ ...state, showSnackbar: false }) }}></Snackbar>

        </>
    )
}
export default memo(ParserSettings)